require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-cuales-son-las-principales-debilidades-de-la-nueva.json") })
        }
      }, "path---es-mx-update-cuales-son-las-principales-debilidades-de-la-nueva");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-cuales-son-las-principales-debilidades-de-la-nueva!./.cache/json/es-mx-update-cuales-son-las-principales-debilidades-de-la-nueva.json
// module id = 926
// module chunks = 231608221292675